import sjcl from 'sjcl';

/**
 * Wraps the specified storage so values are en/decrypted.
 *
 * @param {string} password The encryption key.
 * @param {Storage} storage The underlying storage.
 */
export function createEncryptedStorage(password, storage) {
  var encrypt = function encrypt(data) {
    return data ? sjcl.encrypt(password, data.toString()) : null;
  };
  var decrypt = function decrypt(data) {
    return data ? sjcl.decrypt(password, data) : null;
  };
  return {
    getItem: function getItem(key) {
      return decrypt(storage.getItem(key));
    },
    setItem: function setItem(key, value) {
      storage.setItem(key, encrypt(value));
    },
    removeItem: function removeItem(key) {
      storage.removeItem(key);
    }
  };
}
export var localStorage = getStorage(window.localStorage);
export var sessionStorage = getStorage(window.sessionStorage);

/**
 * Creates an object storage that serializes and deserializes JSON.
 */
export function createObjectStorage(storage) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    getItem: function getItem(key) {
      var got = storage.getItem(prefix + key);
      if (!got) {
        return null;
      }
      return JSON.parse(got);
    },
    setItem: function setItem(key, value) {
      if (value === null || value === undefined) {
        return storage.removeItem(prefix + key);
      }
      storage.setItem(prefix + key, JSON.stringify(value));
    },
    removeItem: function removeItem(key) {
      storage.removeItem(prefix + key);
    }
  };
}

// In Private Mode on iOS, setting items in the storage fails.
// We wrap it to make sure we can make it at least not crash.
function getStorage(storage) {
  try {
    storage.setItem('supported', 'true');
    storage.removeItem('supported');
  } catch (err) {
    var map = new Map();
    storage = {
      getItem: function getItem(item) {
        var r = map.get(item);
        return r === undefined ? null : r;
      },
      setItem: function setItem(item, value) {
        return map.set(item, value === undefined || value === null ? value : value.toString());
      },
      removeItem: function removeItem(item) {
        return map.delete(item);
      }
    };
  }
  return storage;
}
//# sourceMappingURL=storage.js.map
